import React, { Fragment } from 'react';
import { TabButton } from './tab-button';
import { CLASSIC_KEY, TAB_BUTTON_LIST, CUSTOM_KEY } from '@src/slide/application/service/theme-color-manager/theme-config';
import Tabs from '@tencent/dui/esm/components/Tabs';

interface ITabButtonGroupProps {
    themeType: string;
    onThemeTypeChange(themeType: string);
}

interface ITabButtonGroupState {
}

export class TabButtonGroup extends React.Component<ITabButtonGroupProps, ITabButtonGroupState> {
    constructor(props) {
        super(props);
    }

    render() {
        return <Fragment>
            <Tabs
                defaultActiveId={this.props.themeType}
                tabBarStyle={{ height: 36 }}
                tabBarSize="small"
                alignment="left"
                indicatorWidth="small"
                onChange={(key) => {
                    this.props.onThemeTypeChange(key);
                }}
            >
                {
                    TAB_BUTTON_LIST.map((item) => {
                        const { key, title } = item;
                        return <Tabs.TabPane tab={title} id={key} key={key} ></Tabs.TabPane>;
                    })
                }
            </Tabs>
        </Fragment>;
    }
}
